import * as React from "react";
import { connect } from "react-redux";
import { RouterProps } from "react-router";
import { OutletContextProps } from "../../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../../hocs/enhanceSectionsSettingsPage";
import AppStateInterface from "../../../interfaces/AppStateInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import SectionsSettingsStudentsNew from "./SectionsSettingsStudentsNew/index";

interface Props extends RouterProps, OutletContextProps {
  section: SectionInterface;
}

const SectionsSettingsStudentsNewPage = (
  props: Props,
): React.ReactElement<any> => {
  React.useEffect(() => {
    props.setActiveMenu("students");
  }, []);
  return <SectionsSettingsStudentsNew section={props.section} />;
};

const pageInfo = {
  title: "生徒の登録",
};

const mapStateToProps = (state: AppStateInterface) => ({
  section: state.currentSection,
});

const EnhancedPage = enhanceSectionsSettingsPage(
  SectionsSettingsStudentsNewPage,
  pageInfo,
);

export default connect(mapStateToProps, null)(EnhancedPage as any);
